import i18n from '../../../shared/i18n';
import BaseModel from "../../../core/components/input-widget/BaseModel";
import DateModel from "../../sales/Date.model";
import {store} from "@/plugins/vuex";
import {getPhoneRuleObj, LOT_NO_REGEX} from "@/plugins/vee-validate";

export default class ReservationModel extends BaseModel {
  inventory_uuid = null;
  auction_uuid = null;
  lot_no = null;
  status = null;
  low = null;
  high = null;
  reserve = null;
  start_price = null;
  reserve_per_unit = null;
  dates = [new DateModel()];
  hide_lot = false;
  use_images_for_auction_gallery = false;
  hide_image_from_catalog = false;

  category_uuid = null;
  department_uuid = null;
  category = null;
  department = null;
  dynamic_fields = {};
  collection_info_enabled = false;
  collection_info_address_1 = null;
  collection_info_address_2 = null;
  collection_info_state = null;
  collection_info_city = null;
  collection_info_zip_code = null;
  collection_info_phone = null;
  collection_info_first_name = null;
  collection_info_last_name = null;
  collection_info_email = null;
  collection_info_notes = null;
  negotiation_status = null;
  auction_date_uuid = null;
  reserve_type = null;
  auction_collection_uuid = null;

  rules = {
    quantity: 'required|min_value:1',
    item_location_uuid: 'required',
    department_uuid: 'required',
    category_uuid: 'required',
    low: 'min_value:1',
    high: 'min_value:1',
    start_price: 'min_value:0',
    reserve: 'min_value:1',
    buy_now_price: 'min_value:1',

    collection_info_email: 'email|max:73',
    collection_info_phone: getPhoneRuleObj(),
    collection_info_notes: `max:150`,
    lot_no: {
      regex: LOT_NO_REGEX
    }
  };

  attributeLabels = {
    lot_no: i18n.t('Lot'),
    status: i18n.t('Status'),
    low: i18n.t('Low'),
    high: i18n.t('High'),
    reserve: i18n.t('Reserve'),
    quantity: i18n.t('Quantity'),
    start_price: i18n.t('Start Price'),
    category_uuid: i18n.t('Category'),
    department_uuid: i18n.t('Department'),
    item_location_uuid: i18n.t('Item Location'),
    hide_lot: i18n.t('Hide Lot'),
    use_images_for_auction_gallery: i18n.t('Auction Gallery Image'),
    hide_image_from_catalog: i18n.t('Hide Image from Catalog'),
    collection_info_enabled: i18n.t('Collection Information'),
    collection_info_address_1: i18n.t('Address 1'),
    collection_info_address_2: i18n.t('Address 2'),
    collection_info_city: i18n.t('City'),
    collection_info_state: i18n.t('State/County'),
    collection_info_zip_code: i18n.t('Zip/Postcode'),
    collection_info_phone: i18n.t('Phone'),
    collection_info_first_name: i18n.t('Contact First Name'),
    collection_info_last_name: i18n.t('Contact Last Name'),
    collection_info_email: i18n.t('Email'),
    collection_info_notes: i18n.t('Collection Notes'),
    negotiation_status: i18n.t('Negotiation Status'),
    reserve_per_unit: i18n.t('Reserve per Unit'),
    auction_date_uuid: i18n.t('Session'),
    reserve_type: i18n.t('Reserve Type'),
    auction_collection_uuid: i18n.t('Collection'),
    specialists_uuids: i18n.t('Specialists'),
  };

  attributeHints = {};

  toJSON() {
    let data = super.toJSON();
    if (data.auction_date_uuid === '') {
      data.auction_date_uuid = null;
    }
    if (data.auction_collection_uuid === '') {
      data.auction_collection_uuid = null;
    }
    return data
  }

  constructor(data = {}) {
    super();

    let tmpData = data;
    if (tmpData.inventory) {
      // Initialize inventory fields in reservation model
      tmpData.dynamic_fields = tmpData.inventory.dynamic_fields;
      if (tmpData.inventory.department_uuid && tmpData.inventory.department) {
        tmpData.department_uuid = tmpData.inventory.department_uuid;
        tmpData.department = tmpData.inventory.department;
      }
      if (tmpData.inventory.category_uuid && tmpData.inventory.category) {
        tmpData.category_uuid = tmpData.inventory.category_uuid;
        tmpData.category = tmpData.inventory.category;
      }
      if (tmpData.inventory.item_location_uuid && tmpData.inventory.item_location) {
        tmpData.item_location_uuid = tmpData.inventory.item_location_uuid;
        tmpData.item_location = tmpData.inventory.item_location;
      }
      tmpData.specialists = tmpData.inventory.specialists;
      tmpData.specialists_uuids = tmpData.inventory.specialists_uuids || [];
    }

    if (tmpData.auction && tmpData.auction.dates && store.state.global.enableContinuousAuction) {
      tmpData.dates = [new DateModel(tmpData.auction.dates[0])]
    }

    Object.assign(this, {...tmpData});
    this.initDynamicFields(this, this.category ? this.category.dynamic_fields_template : null);
  }

  initDynamicFields(object, dynamicFieldsTemplate = null) {
    if (this.inventory && this.inventory.is_grouped_item && store.state && store.state.global && store.state.global.defaultItemDynamicFieldsTemplate) {
      return super.initDynamicFields(object, store.state.global.defaultItemDynamicFieldsTemplate);
    }

    return super.initDynamicFields(object, dynamicFieldsTemplate);
  }
}
